import { useContext, useEffect, useState } from 'react'
import { useFormik } from 'formik';
import * as Yup from "yup";
import { CorporateStepperContext } from '../../CorporateStepperContext';
import { Button } from 'components/atoms/Button/StyledButton';
import YupPassword from 'yup-password'
import Select from 'react-select';
import { customStyles } from 'shared/style';
import clsx from 'clsx';
import { link_privacy, link_terms } from 'shared/const';
import useMediaQuery from 'hook/useMediaQuery';
import { MediaTablet } from 'api/const/MediaQuery';
import { StepperHeader } from '../../../sharedComponents';
import { Logo } from 'components/atoms';
import { CorporateInfo, initialCorporateInfo, ModalType, OptionTypes } from 'components/types/types';
import { postRegisterCompany } from 'api/calls';
import { CompanyRegisterRequest } from 'components/types';
import { AppGeneralContext } from 'shared/GeneralContext/GeneralContext';
import { postCitiesList } from 'api/Api';

YupPassword(Yup)

const CorporateInfoSchema = Yup.object().shape({
  companyName: Yup.string()
    .min(3, 'Too Short!, min 3 char')
    .max(70, 'Too Long!, max 70 char')
    .required('Please complete this required field.'),
  city: Yup.object().shape({
    value: Yup.string()
      .required('Please complete this required field.'),
  }),
  department: Yup.object().shape({
    value: Yup.string().required('Please select an option from the dropdown menu.')
  }).required('Please select an option from the dropdown menu.'),
  level: Yup.object().shape({
    value: Yup.string().required('Please select an option from the dropdown menu.')
  }).required('Please select an option from the dropdown menu.'),
  jobTitle: Yup.string()
    .min(3, 'Too Short!, min 3 char')
    .max(70, 'Too Long!, max 70 char')
    .required('Please complete this required field.'),
  termsChecked: Yup.boolean()
    .oneOf([true], "The terms and conditions must be accepted."),
  privacyChecked: Yup.boolean()
    .oneOf([true], "Please read and accept privacy."),
});

export const StepCorporateInfo = (props: any) => {
  const { setErrorModal, setModal, setClosedModal, setLoadingModal } = useContext(AppGeneralContext)

  const ctx = useContext(CorporateStepperContext)
  const [corporateInfo] = useState<CorporateInfo>({
    ...initialCorporateInfo
  })
  const tablet = useMediaQuery(MediaTablet)
  const [cities, setCities] = useState<OptionTypes[]>()
  const [city, setCity] = useState<string>("")

  function isNotEmpty(par: string | undefined | null) {
    if (par === "" || par === undefined || par === null) {
      return false
    }
    return true
  }



  useEffect(() => {
    if (isNotEmpty(ctx.companyName)) {
      formik.setFieldValue("companyName", ctx.companyName)
    } else {
      formik.setFieldValue("companyName", "")
    }
    if (isNotEmpty(ctx.cityOption.value)) {
      formik.setFieldValue("city", ctx.cityOption)
    } else {
      formik.setFieldValue("city", { value: "", label: "" })
    }
  }, [ctx.companyName, ctx.cityOption])

  useEffect(() => {
    if (city.length >= 3) {
      postCitiesList({ data: city }).then((res) => {

        if (!res.isSuccess || !res.response) {
          setErrorModal(res.error)
          return false
        }

        const response = res.response.data
        setCities(response)
      })
    } else {
      setCities([])
    }
  }, [city.length])

  useEffect(() => {
    postCitiesList({ data: city }).then((res) => {

      if (!res.isSuccess || !res.response) {
        setErrorModal(res.error)
        return false
      }

      const response = res.response.data
      setCities(response)
    })


  }, [])


  const formik = useFormik<CorporateInfo>({
    initialValues: corporateInfo,
    validationSchema: CorporateInfoSchema,
    enableReinitialize:true,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      setLoadingModal()

      ctx.setCompanyName(values.companyName)
      ctx.setCity(values.city.value);
      ctx.setDepartment(values.department)
      ctx.setLevel(values.level)
      ctx.setTermsChecked(values.termsChecked)
      ctx.setPrivacyChecked(values.privacyChecked)
      ctx.setJobTitle(values.jobTitle)

      const sectors = ctx.sectors && ctx.sectors.length !== 0 ? ctx.sectors.map(x => x.value) : []
      const reasonsOption = ctx.reasons && ctx.reasons.length !== 0 ? ctx.reasons.map(x => {
        if (x.label.includes("Other")) {
          return {
            id: x.value,
            value: x.value,
            label: x.label,
            hasDescription: true,
            description: ctx.reasonsDescription
          }
        } else {
          return {
            id: x.value,
            value: x.value,
            label: x.label,
            hasDescription: false,
          }
        }
      }) : []

      const registerRequest: CompanyRegisterRequest = {
        linkedInId: ctx.linkedInId,
        firstName: ctx.firstName,
        lastName: ctx.lastName,
        email: ctx.email,
        password: ctx.password,
        departmentId: values.department.value,
        levelId: values.level.value,
        jobTitle: values.jobTitle,
        name: values.companyName,
        city: values.city.value,
        guestUserId: ctx.guestID ? ctx.guestID : undefined,
        sectorsIds:sectors,
        reasons: reasonsOption
      }

    

      var registerCompanyResponse = await postRegisterCompany(registerRequest);
      setSubmitting(false)

      if (!registerCompanyResponse.isSuccess || !registerCompanyResponse.response) {
      
        setErrorModal(registerCompanyResponse.error)
        return
      }
 
      setClosedModal()
      props.nextStep()
    }
  })


  return (
    <div
      className={clsx(
        'pe-3 mt-3',
        { 'd-none': !props.isActive },

      )} >
      <StepperHeader stepperTitle={'Corporate info'} />

      <form onSubmit={formik.handleSubmit} autoComplete='off'>

        {/* companyName */}
        <label
          className='text-black mt-3'
          htmlFor="companyName">
          Company Name<sup className='text-error' style={{ fontSize: "16px" }}>*</sup>
        </label>
        <input
          autoComplete="new-password"
          placeholder='Your Company Name'
          {...formik.getFieldProps('companyName')}
          className="form-input"
          type="text"
          onChange={formik.handleChange}
          onBlur={() => formik.setFieldTouched("companyName", true)}
          value={formik.values.companyName}
          name="companyName"
        />
        {formik.errors.companyName && formik.touched.companyName && <div className='text-error ms-2' id="companyName">{formik.errors.companyName}</div>}


        {/* city */}
        <label
          className='text-black mt-3'
          htmlFor="city">City<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
        <Select
          {...formik.getFieldProps('city')}
          options={cities ? cities : []}
          onChange={option => formik.setFieldValue('city', option)}
          onBlur={() => formik.setFieldTouched("city", true)}
          placeholder='Select your city'
          captureMenuScroll={true}
          name={'city'}
          className='w-100'
          onInputChange={(input) => setCity(input as string)}
          styles={customStyles}
          isSearchable
          value={!!formik.values.city.value ? formik.values.city : null}
        />
        {formik.errors.city && formik.touched.city && <div className='text-error' id="companyName">{formik.errors.city.value}</div>}

        {/* Department*/}
        <label className='text-black mt-3' htmlFor="department">Department<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>

        <Select
          {...formik.getFieldProps('department')}
          className='w-100'
          isSearchable
          onChange={option => { formik.setFieldValue('department', option) }}
          onBlur={() => formik.setFieldTouched("department", true)}
          options={ctx.departments}
          captureMenuScroll={true}
          placeholder='Select your department'
          styles={customStyles}
          value={!!formik.values.department.label ? formik.values.department : null}
          components={{ IndicatorSeparator: () => null }}
        />
        {formik.errors.department && formik.touched.department && <div className='text-error ms-2' id="option">{formik.errors.department.value}</div>}


        {/* level*/}
        <label className='text-black mt-3' htmlFor="level">Level<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>

        <Select
          isSearchable
          className='w-100 '
          {...formik.getFieldProps('level')}
          onChange={option => { formik.setFieldValue('level', option) }}
          onBlur={() => formik.setFieldTouched("level", true)}
          options={ctx.levels}
          captureMenuScroll={true}
          placeholder='Select your level'
          styles={customStyles}
          value={!!formik.values.level.label ? formik.values.level : null}
          components={{ IndicatorSeparator: () => null }}
        />
        {formik.errors.level && formik.touched.level && <div className='text-error ms-2' id="option">{formik.errors.level.value}</div>}


        {/* jobTitle */}
        <label className='text-black mt-3' htmlFor="jobTitle">Job title<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
        <input
          autoComplete="new-password"
          placeholder='Your job title'
          {...formik.getFieldProps('jobTitle')}
          className="form-input"
          type="text"
          onChange={formik.handleChange}
          onBlur={() => formik.setFieldTouched("jobTitle", true)}
          value={formik.values.jobTitle}
          name="jobTitle"
        />
        {formik.errors.jobTitle && formik.touched.jobTitle && <div className='text-error ms-2' id="jobTitle">{formik.errors.jobTitle}</div>}


        <div className='d-flex align-items-baseline mt-5'>
          <input
            autoComplete="new-password"
            className='me-3'
            {...formik.getFieldProps('termsChecked')}
            onChange={formik.handleChange}
            type="checkbox"
            id="termsChecked"
            name="termsChecked"
            value="termsChecked"
          />
          <span className='font-size-p fw-400'>I declare that I accept the <a href={link_terms} target='_blank' rel="noreferrer" className='link-primary-pink-sm'>Terms and condition</a><sup className='text-error' style={{ fontSize: "16px" }}>*</sup></span>
        </div>
        {formik.errors.termsChecked && formik.touched.termsChecked && <div className='text-error ms-2' id="termsChecked">{formik.errors.termsChecked}</div>}


        <div className='d-flex align-items-baseline mt-3'>
          <input
            autoComplete="new-password"
            className='me-3'
            {...formik.getFieldProps('privacyChecked')}
            onChange={formik.handleChange}
            type="checkbox"
            id="privacyChecked"
            name="privacyChecked"
            value="privacy" />
          <span className='font-size-p fw-400'>I declare to accept the <a href={link_privacy} target='_blank' rel="noreferrer" className='link-primary-pink-sm'>Privacy Policy</a><sup className='text-error' style={{ fontSize: "16px" }}>*</sup></span>
        </div>
        {formik.errors.privacyChecked && formik.touched.privacyChecked && <div className='text-error ms-2' id="privacyChecked">{formik.errors.privacyChecked}</div>}

        <div className="d-flex flex-row justify-content-between mt-4 mb-4  stepper_navigator ">
          <button
            type='button'
            className=" stepper_navigator_btn  d-flex justify-content-start  align-items-center  h-100"
            onClick={() => { props.previousStep() }} >
            <Logo className="w-20 first me-2 rotate-180 " colorLogo="#FF3F6B" />
            <span> Back </span>
          </button>
          <div className="ms-1 me-1" />
          <div className="h-100 w-100  d-flex justify-content-end">
            <Button
              disabled={
                formik.isSubmitting
                || !formik.isValid
                || !formik.touched
              }
              type="submit"
              className=""
              color="var(--white)"
              background="var(--primary)"
              borderColor="var(--primary)"
              fontWeight={"800"}
              uppercase
              primary
              text="register"
            />
          </div>

        </div>



      </form >
    </div >
  )
}



